/*eslint-disable*/
import React, { useState } from 'react';
import BoundariesSection from 'mapcontrols/sections/BoundariesSection/BoundariesSection';
import DemographicsSection from 'mapcontrols/sections/DemographicsSection/DemographicsSection';
import ReferenceLayersSection from 'mapcontrols/sections/ReferenceLayersSection/ReferenceLayersSection';
import DensitySection from 'mapcontrols/sections/DensitySection/DensitySection';
import ProximitySection from 'mapcontrols/sections/ProximitySection/ProximitySection';
import InspectionResults from 'mapcontrols/sections/InspectionResultsSection/InspectionResults';
import Filter from 'ui-kit/old/filter';
import { AccordionSection } from '../subComponents';
import ReportsSection from 'mapcontrols/sections/ReportsSection/ReportsSection';
import * as Styled from './styles';
import { AZ_ACCOUNT_MAP_SECTIONS } from 'mapcontrols/constants';
import { ChipList } from 'modules/Modals/old/FilterModal/components/ChipsList';
import { HIDE_EYE_ICON, SHOW_EYE_ICON } from 'assets/icons';
import { Img } from 'ui-kit';

const ArizonaPublicLayerPanel = ({
  onToggle,
  isExpanded = true,
  mapLegendImages = {},
  calculableBoundaryLayers = [],
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeLayerIds = [],
  onLayerToggle = () => {},
  calcPolygonSelections = [],
  calcPolygonLabelSelections = [],
  onCalculablePolygonChange = () => {},
  onCalculablePolygonLabelChange = () => {},
  demographicSelection = null,
  onDemographicChange = () => {},
  densitySelection = null,
  onDensityChange = () => {},
  onRetailerPointsToggle = () => {},
  proximitySelection = null,
  onProximityLayerToggle = () => {},
  onProximityRangeChange = () => {},
  onProximityPlaceChange = () => {},
  mapFilterParams = {},
  inspectionFailureRateSelection = null,
  onInspectionFailureRateMapFilter = () => {},
}) => {
  const togglePanel = () => {
    if (onToggle) onToggle(!isExpanded);
  };
  const [activeSections, setActiveSections] = useState(AZ_ACCOUNT_MAP_SECTIONS);
  const [showChips, setShowChips] = useState(true);

  const {
    onChangeTabs = () => {},
    handleExportDataChange = () => {},
    filterMapping = {},
    getApi = () => {},
    setCurrentPage = () => {},
    retailersCount = 0,
    locationSearch = '',
  } = mapFilterParams || {};

  const onSectionToggle = (id) => {
    setActiveSections((state) => ({ ...state, [id]: !state[id] }));
  };

  return (
    <Styled.MapFeaturesWrapper>
      <Styled.Panel
        className="leaflet-biglayerpanel-header"
        tabIndex="0"
        aria-label="Open or close this panel"
        id="map-biglayerpanel-header"
        onClick={togglePanel}
      >
        <button
          aria-expanded={isExpanded}
          className="leaflet-biglayerpanel-togglebutton"
          aria-controls="map-biglayerpanel-panel"
          id="map-biglayerpanel-togglebutton"
          tabIndex="-1"
          aria-hidden="true"
        >
          &times;
        </button>
        Tobacco Retailer Queries
      </Styled.Panel>

      <div
        className="leaflet-biglayerpanel-panel"
        id="map-biglayerpanel-panel"
        aria-labelledby="map-biglayerpanel-togglebutton"
        style={{ display: isExpanded ? 'block' : 'none' }}
      >
        <Styled.MapFiltersWrapper>
          <Styled.ChipsWrapper className="table-filters">
            <Styled.ButtonWrapper>
              <Styled.ListViewButton
                onClick={() => onChangeTabs('List View')}
              >{`< Go to List View`}</Styled.ListViewButton>
              <Styled.HideChipsButton
                onClick={() => {
                  setShowChips((prev) => !prev);
                }}
              >
                <Img aria-hidden src={showChips ? HIDE_EYE_ICON : SHOW_EYE_ICON} size={[16, 28]} />
                <span>{showChips ? 'Hide Chips' : 'Show chips'}</span>
              </Styled.HideChipsButton>
              {<Styled.RetailersCount>{retailersCount} retailers</Styled.RetailersCount>}
            </Styled.ButtonWrapper>
            {showChips && (
              <ChipList
                hideDelete
                withoutScroll
                filterMapping={filterMapping}
                getApi={getApi}
                setCurrentPage={setCurrentPage}
                isPublic
              />
            )}
          </Styled.ChipsWrapper>
        </Styled.MapFiltersWrapper>
        <div className="leaflet-biglayerpanel-accordion">
          <DensitySection
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeLayerIds={activeLayerIds}
            onLayerToggle={onLayerToggle}
            densitySelection={densitySelection}
            onDensityChange={onDensityChange}
            onRetailerPointsToggle={onRetailerPointsToggle}
          />

          <ProximitySection
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeLayerIds={activeLayerIds}
            onLayerToggle={onLayerToggle}
            densitySelection={densitySelection}
            proximitySelection={proximitySelection}
            onProximityLayerToggle={onProximityLayerToggle}
            onProximityRangeChange={onProximityRangeChange}
            onProximityPlaceChange={onProximityPlaceChange}
          />

          <InspectionResults
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
            activeLayerIds={activeLayerIds}
            onLayerToggle={onLayerToggle}
            isPublic
            getApi={getApi}
            setCurrentPage={setCurrentPage}
            handleExportDataChange={handleExportDataChange}
            inspectionFailureRateSelection={inspectionFailureRateSelection}
            onInspectionFailureRateMapFilter={onInspectionFailureRateMapFilter}
            locationSearch={locationSearch}
          />

          <AccordionSection
            title="Map Features"
            id="mapFeatures"
            activeSections={activeSections}
            onSectionToggle={onSectionToggle}
            collapsedArrowIcon={collapsedArrowIcon}
            expandedArrowIcon={expandedArrowIcon}
          >
            <BoundariesSection
              activeSections={activeSections}
              onSectionToggle={onSectionToggle}
              collapsedArrowIcon={collapsedArrowIcon}
              expandedArrowIcon={expandedArrowIcon}
              onCalculablePolygonChange={onCalculablePolygonChange}
              onCalculablePolygonLabelChange={onCalculablePolygonLabelChange}
              calcPolygonSelections={calcPolygonSelections}
              calcPolygonLabelSelections={calcPolygonLabelSelections}
              calculableBoundaryLayers={calculableBoundaryLayers}
              className="nested-accordion"
            />
            <ReferenceLayersSection
              activeSections={activeSections}
              onSectionToggle={onSectionToggle}
              collapsedArrowIcon={collapsedArrowIcon}
              expandedArrowIcon={expandedArrowIcon}
              activeLayerIds={activeLayerIds}
              onLayerToggle={onLayerToggle}
              mapLegendImages={mapLegendImages}
              className="nested-accordion"
            />
            <DemographicsSection
              calculableBoundaryLayers={calculableBoundaryLayers}
              collapsedArrowIcon={collapsedArrowIcon}
              expandedArrowIcon={expandedArrowIcon}
              activeSections={activeSections}
              onSectionToggle={onSectionToggle}
              demographicSelection={demographicSelection}
              onDemographicChange={onDemographicChange}
              className="nested-accordion"
            />
          </AccordionSection>
        </div>
      </div>
    </Styled.MapFeaturesWrapper>
  );
};

export default ArizonaPublicLayerPanel;
